/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import useOfficialDocuments from "./content";
import { Row, Col, Spinner } from 'reactstrap';
import { useWorkFlow, LOCK_BUTTON } from "../../../contexts/workflow";
import { _translate as t } from "../../../../services/core";
import env from "../../../../services/environment";
import { _translate } from "../../../../services/core";
import useAnalytics from "../../../../services/analytics";
var Index = function Index() {
  // Utilisation du context pour récupérer le diag et la communauté attachée.
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector,
    dispatcher = _useWorkFlow.dispatcher;
  var analytics = useAnalytics(collector);
  var diagId = collector.diagId;
  var community = collector.diag ? collector.diag.community : {
    polygon: null,
    polygonColor: null
  };

  // Utilisation des documents officiels
  var _useOfficialDocuments = useOfficialDocuments(),
    isValid = _useOfficialDocuments.isValid,
    props = _useOfficialDocuments.props,
    actions = _useOfficialDocuments.actions;
  useEffect(function () {
    if (!collector && !collector.diag) {
      return;
    }
    dispatcher({
      type: LOCK_BUTTON,
      value: true
    });
    actions.start([collector.diag.community.id]);
  }, []);
  useEffect(function () {
    dispatcher({
      type: LOCK_BUTTON,
      value: !isValid
    });
  }, [isValid]);
  useEffect(function () {
    if (props.data && diagId === 1295) {
      actions.validate(true);
    }
  }, [collector.diag, props.data]);
  if (!props.data && !isValid || !collector.diag) {
    // TOUT SAUF ROUEN
    return /*#__PURE__*/React.createElement(Spinner, {
      color: "primary"
    });
  }

  /**
   * ROUEN
   */
  if (diagId === 1295) {
    // SEULEMENT ROUEN
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      className: "col-12 d-flex justify-content-center align-items-start flex-column",
      style: {
        backgroundColor: '#eee',
        borderRadius: '15px',
        padding: '15px'
      }
    }, t('collectorapp_accept_documents_right_implicit'), /*#__PURE__*/React.createElement("p", {
      className: "m-0"
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(env.get('admin_url'), "/shared/community/").concat(collector.diag.community.id, "/information"),
      onClick: function onClick() {
        return analytics.post.event('read-cgu');
      },
      target: "blank"
    }, /*#__PURE__*/React.createElement("b", null, _translate('collectorapp_cgu_know_more'))))));
  }
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "col-2 d-flex justify-content-end align-items-center"
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      padding: '10px',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: isValid,
    id: "cgu_accept",
    onChange: function onChange(e) {
      return actions.validate(e.target.checked);
    }
  }), ' ', /*#__PURE__*/React.createElement("br", null), ' ')), /*#__PURE__*/React.createElement(Col, {
    className: "col-10 d-flex justify-content-start align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-align-left"
  }, /*#__PURE__*/React.createElement("label", {
    for: "cgu_accept",
    style: {
      fontSize: '0.75em',
      color: '#555',
      textAlign: 'left'
    }
  }, t('collectorapp_accept_documents_right'), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
    href: "".concat(env.get('admin_url'), "/shared/community/").concat(collector.diag.community.id, "/information"),
    onClick: function onClick() {
      return analytics.post.event('read-cgu');
    },
    target: "blank"
  }, _translate('collectorapp_cgu_know_more')))))));
};
export default Index;